import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import api from '../../../api';

const FindOutMoreSection = () => {
  const { miniSlug, slug } = useParams();
  const [sectionData, setSectionData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await api.get(`${process.env.REACT_APP_API_URL}/api/${miniSlug}/${slug}/find-out-more`);
        setSectionData(response.data);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [miniSlug, slug]);

  const imagesCount = sectionData?.items?.length || 0;
  const imagesCountMin = 3;
  const imagesCountMax = 5;
  const imagesCountToShow = Math.max(imagesCountMin, Math.min(imagesCount, imagesCountMax));
  const shouldLoop = imagesCount > imagesCountToShow;

  const settings = {
    dots: false,
    infinite: shouldLoop,
    speed: 500,
    slidesToShow: imagesCountToShow,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    responsive: [
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 2
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1
        }
      }
    ]
  };

  if (loading || error || !sectionData?.items?.length) return <></>;

  return (
    <section className="find_out_more_section  pb_80" id="more">
      <div className="container position-relative"><div className="sec-title text-center">
                            <h2>{sectionData.title}</h2>
                        </div>
      

        <Slider {...settings} className="find-out-carousel">
          {sectionData.items.map((card, index) => {
            // Determine the correct href depending on type
            let href = '#';
            if (card.type === 'pdf' && card.pdf) {
              href = `${process.env.REACT_APP_API_URL}/public/${card.pdf}`;
            } else if (card.type === 'link' && card.link) {
              href = card.link;
            }

            // Determine target
            const target = card.target || '_self';
            const rel = target === '_blank' ? 'noopener noreferrer' : '';

            return (
              <div className="item" key={index}>
                <div className="find-card">
                  <div className="card-image-wrapper">
                    <img
                      src={
                        card.image
                          ? `${process.env.REACT_APP_API_URL}/public/${card.image}`
                          : '/default-images/find-out-more.jpg'
                      }
                      alt={card.title}
                      className="img-fluid"
                    />
                  </div>
                  <div className="actions">
                    <a
                      className="read"
                      href={href}
                      target={target}
                      rel={rel}
                    >
                      {card.title}
                    </a>
                  </div>
                </div>
              </div>
            );
          })}
        </Slider>
      </div>
    </section>
  );
};

export default FindOutMoreSection;
